<template>
  <header id="header" class="jc-nav">
    <div class="header-contact hidden-xs">
      <div class="jc-container header-contact__inner">
        <div class="header-contact__left">
          <span>电话：15116103906</span>
          <span>邮箱：suling@wcjudian.com</span>
          <span>7×24 小时服务支持</span>
        </div>
        <div class="header-contact__right">制造业数字化转型 · 软件产品 · 咨询培训</div>
      </div>
    </div>

    <div class="jc-container jc-nav__inner">
      <router-link class="jc-brand" to="/home" @click.native="closeMobileMenu">
        <img class="jc-brand__logo" src="../assets/img/company_logo.png" alt="伟创聚点">
        <img class="jc-brand__name" :src="isDark ? brandNameDark : brandNameLight" alt="伟创聚点">
      </router-link>

      <ul class="jc-nav__links">
        <li
          v-for="(item, index) in navList"
          :key="index"
          class="jc-nav__item"
          :class="{ 'jc-dropdown': item.children.length > 0 }"
        >
          <router-link
            class="jc-nav__link"
            :class="{ 'is-active': isTopActive(item) }"
            :to="item.path"
          >
            {{ item.name }}
            <span v-if="item.children.length > 0" class="jc-caret">⌄</span>
          </router-link>
          <div v-if="item.children.length > 0" class="jc-dropdown__menu">
            <router-link v-for="(child, childIndex) in item.children" :key="childIndex" :to="child.path">
              <span class="sub-ico">{{ child.name.slice(0, 1) }}</span>
              <span>
                <span class="sub-title">{{ child.name }}</span>
                <span class="sub-desc">{{ child.desc }}</span>
              </span>
            </router-link>
          </div>
        </li>
      </ul>

      <div class="jc-nav__actions">
        <button class="jc-theme-toggle" type="button" :aria-label="isDark ? '切换到浅色模式' : '切换到深色模式'" @click="toggleTheme">
          <svg v-if="isDark" class="jc-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"/></svg>
          <svg v-else class="jc-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>
        </button>
        <router-link class="jc-btn jc-btn--soft" to="/contactus">联系我们</router-link>
        <router-link class="jc-btn jc-btn--primary" to="/software">查看方案</router-link>
      </div>

      <button class="jc-burger" type="button" aria-label="打开导航菜单" @click="toggleMobileMenu">
        <span>{{ mobileOpen ? '×' : '☰' }}</span>
      </button>
    </div>

    <div class="jc-mobile-menu" :class="{ 'is-open': mobileOpen }">
      <template v-for="(item, index) in navList">
        <router-link :key="item.path" :to="item.path" @click.native="closeMobileMenu">{{ item.name }}</router-link>
        <router-link
          v-for="(child, childIndex) in item.children"
          :key="index + '-' + childIndex"
          class="mobile-child"
          :to="child.path"
          @click.native="closeMobileMenu"
        >
          {{ child.name }}
        </router-link>
      </template>
    </div>
  </header>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      mobileOpen: false,
      isDark: document.documentElement.getAttribute('data-theme') !== 'light',
      brandNameDark: require('../assets/img/name_white.png'),
      brandNameLight: require('../assets/img/name_ink.png'),
      navList: [
        {
          name: "首页",
          path: "/home",
          children: []
        },
        {
          name: "软件产品",
          path: "/software",
          children: [
            { name: "订单管理系统", path: "/software/order", desc: "订单、排程与交付协同" },
            { name: "MES制造执行系统", path: "/software/mes", desc: "车间执行与生产透明化" },
            { name: "WMS仓储管理系统", path: "/software/wms", desc: "库内作业与库存精准管理" },
            { name: "设备云平台", path: "/software/device", desc: "设备接入、监控与数据分析" }
          ]
        },
        {
          name: "咨询培训",
          path: "/consulting",
          children: [
            { name: "制造工艺指导", path: "/consulting/process", desc: "工艺诊断、参数优化与标准化" },
            { name: "流程优化咨询", path: "/consulting/flow", desc: "跨部门流程梳理与效率提升" },
            { name: "管理能力培训", path: "/consulting/training", desc: "班组长、主管与管理层赋能" }
          ]
        },
        {
          name: "相关服务",
          path: "/service",
          children: []
        },
        {
          name: "新闻动态",
          path: "/newsinformation",
          children: []
        },
        {
          name: "公司介绍",
          path: "/companyintroduction",
          children: []
        }
      ]
    };
  },
  methods: {
    isTopActive(item) {
      if (!this.$route || !this.$route.path) return false;
      if (item.path === "/home") return this.$route.path === "/home" || this.$route.path === "/";
      return this.$route.path.indexOf(item.path) === 0;
    },
    toggleMobileMenu() {
      this.mobileOpen = !this.mobileOpen;
    },
    closeMobileMenu() {
      this.mobileOpen = false;
    },
    toggleTheme() {
      this.isDark = !this.isDark;
      document.documentElement.setAttribute('data-theme', this.isDark ? 'dark' : 'light');
      try { localStorage.setItem('jc-theme', this.isDark ? 'dark' : 'light'); } catch (e) {}
    }
  }
};
</script>

<style scoped>
#header {
  box-shadow: 0 1px 0 rgba(226, 232, 240, 0.65);
}

.header-contact {
  background: var(--jc-ink);
  color: #cbd5e1;
  font-size: 13px;
}

.header-contact__inner {
  min-height: 36px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.header-contact__left {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 18px;
}

.header-contact__right {
  color: #93c5fd;
  font-weight: 600;
}

.jc-brand {
  white-space: nowrap;
}

.jc-nav__links {
  margin-left: auto;
  margin-right: 18px;
}

.jc-nav__actions .jc-btn {
  height: 42px;
  min-width: auto;
  padding-left: 18px;
  padding-right: 18px;
}

.jc-burger {
  font-family: var(--jc-font-display);
  font-size: 22px;
  line-height: 1;
}

.mobile-child {
  padding-left: 28px !important;
  color: var(--jc-text-muted) !important;
  font-size: 14px;
}

@media (max-width: 1200px) {
  .jc-nav__link {
    padding-left: 10px;
    padding-right: 10px;
    font-size: 14px;
  }

  .jc-nav__actions .jc-btn {
    padding-left: 12px;
    padding-right: 12px;
  }
}

@media (max-width: 768px) {
  #header {
    position: sticky;
    top: 0;
    z-index: var(--jc-z-nav);
  }

  .jc-nav__inner {
    min-height: 64px;
  }

  .jc-brand {
    font-size: 18px;
  }

  .jc-brand__logo {
    height: 44px;
  }

  .jc-brand__name {
    height: 26px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue